import React, { Component } from 'react';
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
} from "react-router-dom";

import * as token from "./util/tokenUtil";

import LoginPage from "./pages/register/LoginPage";
import JoinAgreePage from "./pages/register/JoinAgreePage";
import JoinSelectHostingPage from "./pages/register/JoinSelectHostingPage";
import JoinInfoPage from "./pages/register/JoinInfoPage";
import JoinCompletePage from "./pages/register/JoinCompletePage";
import SelfMessageCreatePage from "./pages/selfmessage/message/page/SelfMessageCreatePage";
import SelfMessageImageListPage from "./pages/selfmessage/image/SelfMessageImageListPage";
import SentListPage from "./pages/sentstat/SentListPage";
import SentDetailPage from "./pages/sentstat/SentDetailPage";
import SentUpdatePage from "./pages/sentstat/SentUpdatePage";
import CashChargePage from "./pages/cash/page/CashChargePage";
import CashChargedHistoryPage from "./pages/cash/page/CashChargedHistoryPage";
import RecommendPage from "./pages/recommend/RecommendPage";
import MyPage from "./pages/mypage/MyPage";
import AnnounceListPage from "./pages/announce/AnnounceListPage";
import AnnounceDetailPage from "./pages/announce/AnnounceDetailPage";
import UseAgreement from "./pages/clause/UseAgreement";
import SpamAgreement from "./pages/clause/SpamAgreement";
import NaverAppClausePage from "./pages/clause/NaverAppClausePage";
import JoinSwitchPage from "./pages/register/JoinSwitchPage";
import HostingCIntro from "./pages/register/hostingIntro/HostingCIntro";
import IntroPage from "./pages/main/IntroPage";
import HostingSwitchPage from "./pages/register/HostingSwitchPage";
import PopUpPage from "./pages/register/PopUpPage";
import HostingSIntro from "./pages/register/hostingIntro/HostingSIntro";
import HostingMIntro from "./pages/register/hostingIntro/HostingMIntro";
import HostingMessagePangIntro from "./pages/register/hostingIntro/HostingMessagePangIntro";
import HostingStoretalkIntro from "./pages/register/hostingIntro/HostingStoretalkIntro";
import EventPage from "./pages/event/EventPage";
import JungKwanJangEventPage from "./pages/event/JungKwanJangEventPage";
import JungKwanJangChuseokEventPage from "./pages/event/JungKwanJangChuseokEventPage";
import RewardIndexPage from "./pages/reward/RewardIndexPage";
import RewardCompletePage from "./pages/reward/RewardCompletePage";
import FAQListPage from "./pages/faq/FAQListPage";
import InquiryCreatePage from "./pages/inquiry/page/InquiryCreatePage";
import InquiryListPage from "./pages/inquiry/page/InquiryListPage";
import InquiryDetailPage from "./pages/inquiry/page/InquiryDetailPage";
import FormListPage from "./pages/form/FormListPage";
import FormCreatePage from "./pages/form/FormCreatePage";
import GoogleAuthCallbackPage from "./pages/mypage/GoogleAuthCallbackPage";
import ShortUrlRedirectPage from "./pages/form/ShortUrlRedirectPage";
import GoogleUseAgreement from "./pages/clause/GoogleUseAgreement";
import BiztingPrivacyPolicyV10Page from "./pages/clause/BiztingPrivacyPolicyV10Page";
import BiztingPrivacyPolicyV11Page from "./pages/clause/BiztingPrivacyPolicyV11Page";
import BiztingPrivacyPolicyV12Page from "./pages/clause/BiztingPrivacyPolicyV12Page";
import BiztingPrivacyPolicyV13Page from "./pages/clause/BiztingPrivacyPolicyV13Page";
import BiztingPrivacyPolicyV14Page from "./pages/clause/BiztingPrivacyPolicyV14Page";
import BiztingTermsOfServiceV11Page from "./pages/clause/BiztingTermsOfServiceV11Page";
import BiztingTermsOfServiceV12Page from "./pages/clause/BiztingTermsOfServiceV12Page";
import HostingAIntro from "./pages/register/hostingIntro/HostingAIntro";
import Hosting2CHEROIntro from "./pages/register/hostingIntro/Hosting2CHEROIntro";
import AttentionIndex from "./pages/naver-login-plus/page/AttentionIndex";
import Dashboard from "./pages/naver-login-plus/page/Dashboard";
import DashboardLogin from "./pages/naver-login-plus/page/DashboardLogin";
import NaverLandingPage from "./pages/naver-login-plus/page/NaverLandingPage";
import NaverOAuthCallbackPage from "./pages/naver-login-plus/page/NaverOAuthCallbackPage";
import MomentOnboardingPage from "./pages/kakao-moment/page/MomentOnboardingPage";
import MomentCreatePage from "./pages/kakao-moment/page/MomentCreatePage";
import MomentListPage from "./pages/kakao-moment/page/MomentListPage";
import MomentReportPage from "./pages/kakao-moment/page/MomentReportPage";
import MomentReservePage from "./pages/kakao-moment/page/MomentReservePage";
import MomentIndex from "./pages/kakao-moment/page/MomentIndex";
import NPassPrivacyPolicy from "./pages/clause/NPassPrivacyPolicy";
import NPassPrivacyPolicyV11 from "./pages/clause/NPassPrivacyPolicy1.1";
import NPassPrivacyPolicyV12 from "./pages/clause/NPassPrivacyPolicy1.2";
import BrandPickPage from "./pages/brandpick/BrandPickPage";
import AdLandingPage from "./pages/landing/AdLandingPage";


class AppRouter extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const accToken = token.getAccessToken();
        const authenticated = accToken !== null;

        return (
            <Router>
                <Routes>
                    {/*초기 소개 페이지 (팝업) */}
                    <Route path="/popup" element={<PopUpPage />} />
                    <Route path="/intro" element={<IntroPage />} />
                    <Route path="/account/login" element={<LoginPage />} />
                    <Route path="/register/agree" element={<JoinAgreePage />} />
                    <Route path="/register/switch" element={<JoinSwitchPage />} />
                    <Route path="/register/hosting" element={<JoinSelectHostingPage />} />
                    <Route path="/register/info" element={<JoinInfoPage />} />
                    <Route path="/register/complete" element={<JoinCompletePage />} />

                    <Route path="/hosting/switch" element={<HostingSwitchPage />} />
                    <Route path="/hosting/cafe24/intro" element={<HostingCIntro />} />
                    <Route path="/hosting/solapi/intro" element={<HostingSIntro />} />
                    <Route path="/hosting/makeshop/intro" element={<HostingMIntro />} />
                    <Route path="/hosting/academy/intro" element={<HostingAIntro />} />
                    <Route path="/hosting/2chero/intro" element={<Hosting2CHEROIntro />} />
                    <Route path="/hosting/message-pang/intro" element={<HostingMessagePangIntro />} />
                    <Route path="/hosting/storetalk/intro" element={<HostingStoretalkIntro />} />

                    <Route path="/" element={<IntroPage />} />
                    <Route path="/landing" element={<AdLandingPage />} />
                    <Route path="/brandpick" element={<BrandPickPage />} />
                    <Route path="/recommend" element={authenticated ? <RecommendPage /> : <Navigate replace to="/account/login" />} />

                    <Route path="/selfmessage/create" element={authenticated ? <SelfMessageCreatePage /> : <Navigate replace to="/account/login" />} />
                    <Route path="/selfmessage/image" element={authenticated ? <SelfMessageImageListPage /> : <Navigate replace to="/account/login" />} />

                    <Route path="/sent/list" element={authenticated ? <SentListPage /> : <Navigate replace to="/account/login" />} />
                    <Route path="/sent/detail/:id" element={authenticated ? <SentDetailPage /> : <Navigate replace to="/account/login" />} />
                    <Route path="/sent/update/:id" element={authenticated ? <SentUpdatePage /> : <Navigate replace to="/account/login" />} />

                    <Route path="/cash/charge" element={<CashChargePage />} />
                    <Route path="/cash/history" element={authenticated ? <CashChargedHistoryPage /> : <Navigate replace to="/account/login" />} />

                    <Route path="/mypage" element={authenticated ? <MyPage /> : <Navigate replace to="/account/login" />} />

                    <Route path="/announce" element={authenticated ? <AnnounceListPage /> : <Navigate replace to="/account/login" />} />
                    <Route path="/announce/detail/:id" element={authenticated ? <AnnounceDetailPage /> : <Navigate replace to="/account/login" />} />
                    <Route path="/announce/faq" element={authenticated ? <FAQListPage /> : <Navigate replace to="/account/login" />} />

                    <Route path="/announce/inquiry/create" element={authenticated ? <InquiryCreatePage /> : <Navigate replace to="/account/login" />} />
                    <Route path="/announce/inquiry" element={authenticated ? <InquiryListPage /> : <Navigate replace to="/account/login" />} />
                    <Route path="/announce/inquiry/detail/:id" element={authenticated ? <InquiryDetailPage /> : <Navigate replace to="/account/login" />} />

                    <Route path="/clause/use" element={<BiztingTermsOfServiceV11Page />} />
                    <Route path="/clause/use/v1.2" element={<BiztingTermsOfServiceV12Page />} />
                    <Route path="/clause/use/v1.1" element={<BiztingTermsOfServiceV11Page forceCurrent />} />
                    <Route path="/clause/use/v1.0" element={<UseAgreement />} />
                    <Route path="/clause/privacy" element={<BiztingPrivacyPolicyV11Page />} />
                    <Route path="/clause/privacy/v1.4" element={<BiztingPrivacyPolicyV14Page />} />
                    <Route path="/clause/privacy/v1.3" element={<BiztingPrivacyPolicyV13Page forceCurrent />} />
                    <Route path="/clause/privacy/v1.2" element={<BiztingPrivacyPolicyV12Page forceCurrent />} />
                    <Route path="/clause/privacy/v1.1-1.1" element={<Navigate replace to="/clause/privacy/v1.2" />} />
                    <Route path="/clause/privacy/v1.1" element={<BiztingPrivacyPolicyV11Page forceCurrent />} />
                    <Route path="/clause/privacy/v1.0" element={<BiztingPrivacyPolicyV10Page />} />
                    <Route path="/clause/spam" element={<SpamAgreement />} />
                    <Route path="/clause/use/google" element={<GoogleUseAgreement/>} />
                    <Route path="/clause/naver/:appUid/:version" element={<NaverAppClausePage />} />
                    <Route path="/clause/sender/privacy" element={<NPassPrivacyPolicyV12 />} />
                    <Route path="/clause/sender/privacy/v1.2" element={<NPassPrivacyPolicyV12 />} />
                    <Route path="/clause/sender/privacy/v1.1" element={<NPassPrivacyPolicyV11 />} />
                    <Route path="/clause/sender/privacy/v1.0" element={<NPassPrivacyPolicy />} />

                    <Route path="/event" element={<EventPage />} />
                    <Route path="/event/jungkwanjang" element={<JungKwanJangEventPage />} />
                    <Route path="/event/jungkwanjang/:couponCode" element={<JungKwanJangEventPage />} />
                    <Route path="/event/jungkwanjang-chuseok" element={<JungKwanJangChuseokEventPage />} />
                    <Route path="/reward/index/:data" element={<RewardIndexPage />} />
                    <Route path="/reward/fn" element={<RewardCompletePage />} />

                    <Route path="/auth/google/callback" element={authenticated ? <GoogleAuthCallbackPage /> : <Navigate replace to="/account/login" />} />
                    <Route path="/form/list" element={authenticated ? <FormListPage /> : <Navigate replace to="/account/login" />} />
                    <Route path="/form/create" element={authenticated ? <FormCreatePage /> : <Navigate replace to="/account/login" />} />

                    {/* Short URL Redirect */}
                    <Route path="/f/:shortId" element={<ShortUrlRedirectPage />} />

                    {/* 관심고객 */}
                    <Route path="/attention" element={<AttentionIndex />} />
                    {/*<Route path="/DashboardLogin" element={<DashboardLogin />} />*/}
                    <Route path="/attention/dashboard" element={authenticated ? <Dashboard /> : <Navigate replace to="/account/login" />} />

                    {/* 수신자 네이버 로그인 랜딩 */}
                    <Route path="/naver/:shortUrl" element={<NaverLandingPage />} />
                    <Route path="/naver/:appUid/callback" element={<NaverOAuthCallbackPage />} />

                    {/* 카카오 모먼트 */}
                    {/* [ROLLBACK] 기존 onboarding 라우트 */}
                    <Route path="/moment" element={<Navigate replace to="/moment/index" />} />
                     <Route path="/moment/description" element={authenticated ? <MomentOnboardingPage /> : <Navigate replace to="/account/login" />} />
                    <Route path="/moment/index" element={<MomentIndex />} />
                    <Route path="/moment/create" element={authenticated ? <MomentCreatePage /> : <Navigate replace to="/account/login" />} />
                    <Route path="/moment/list" element={authenticated ? <MomentListPage /> : <Navigate replace to="/account/login" />} />
                    <Route path="/moment/report/:kakaoAdId" element={authenticated ? <MomentReportPage /> : <Navigate replace to="/account/login" />} />
                    <Route path="/moment/reserve/:kakaoAdId" element={authenticated ? <MomentReservePage /> : <Navigate replace to="/account/login" />} />

                </Routes>
            </Router>
        )
    }
}

export default AppRouter;
